import { List } from "immutable";
import { createAction } from "redux-actions";
import * as M from "../models";
import { Thunk } from "./Thunk";
import { Api } from "../services/Api";
import Settings from "../settings";

const prefix = "ADMIN_NAV_LIST_";

export class Constants {
    public static RECEIVED_ALL = prefix + "RECEIVED_ALL";
    public static UPDATED_LIST = prefix + "UPDATED_LIST";
}

export interface AllDataReceivedPayload {
    navItems: M.AdminNav.NavListItem[];
    types: M.Generic.TypeDefinition[];
}

export type UpdateNavItemsPayload = List<M.AdminNav.NavListItem>;

export const loadData = (): Thunk => async (dispatch, getState) => {
    const state = getState();
    const api = new Api(state);

    // don't load admin data if not an admin
    if (state.auth.data && !state.auth.data.isAdmin)
        return;

    const typesPromise = api.get<M.Generic.TypeDefinition[]>(Api.endpoints.admin.nav.types);
    const navPromise = api.get<M.AdminNav.NavListItem[]>(Api.endpoints.admin.nav.list, { queryParams: { appId: Settings.AppID }});

    Promise.all([typesPromise, navPromise]).then((results) => {
        const types = results[0].data;
        const navItems = results[1].data;
        if (navItems && types) {
            dispatch(onAllReceived(navItems, types));
        }
        else {
            dispatch(onAllReceived([], []));
        }
    }, (err) => {
        dispatch(onAllReceived([], []));
    }).then(() => {

    });
};

export const updateNavItems = createAction<UpdateNavItemsPayload, List<M.AdminNav.NavListItem>>(
    Constants.UPDATED_LIST, (navItems) => (navItems),
);

export const onAllReceived = createAction<AllDataReceivedPayload, M.AdminNav.NavListItem[], M.Generic.TypeDefinition[]>(
    Constants.RECEIVED_ALL, (navItems, types) => ({ navItems, types}),
);



// WEBPACK FOOTER //
// ./src/actions/AdminNavListActions.ts